import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Input, Select, Spin } from 'antd';
import { useBusinessHoursQuery, useUpdateBusinessHoursMutation } from '../../queries/settings';
import { US_TIMEZONES } from '../../utils/timezones';
import { Card, CardHead } from '../../components';

const DEFAULT_RANGE = { start: '09:00', end: '17:00' };

export default function BusinessHoursCard() {
  const { data, isPending } = useBusinessHoursQuery();
  const { mutate, isPending: saving } = useUpdateBusinessHoursMutation();
  const [rows, setRows] = useState([]);
  const [timezone, setTimezone] = useState('');

  useEffect(() => {
    if (!data) return;
    setRows(data.days.map((d) => ({ key: d.key, day: d.day, closed: d.closed, range: d.ranges?.[0] || DEFAULT_RANGE })));
    setTimezone(data.timezone || 'America/Chicago');
  }, [data]);

  const patch = (key, change) => setRows((all) => all.map((r) => (r.key === key ? { ...r, ...change } : r)));
  const save = () =>
    mutate({ timezone, days: rows.map((r) => ({ key: r.key, closed: r.closed, ranges: r.closed ? [] : [r.range] })) });

  return (
    <Card aria-labelledby="hours-title">
      <CardHead>
        <h2 id="hours-title">Business hours</h2>
        <span>what the assistant tells callers</span>
      </CardHead>
      {isPending ? (
        <Spin />
      ) : (
        <>
          <Select
            aria-label="Timezone"
            value={timezone}
            onChange={setTimezone}
            options={US_TIMEZONES}
            style={{ width: 200, marginBottom: 12 }}
          />
          {rows.map((r) => (
            <div key={r.key} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
              <strong style={{ width: 96 }}>{r.day}</strong>
              <Checkbox checked={!r.closed} onChange={(e) => patch(r.key, { closed: !e.target.checked })}>
                Open
              </Checkbox>
              {!r.closed && (
                <>
                  <Input
                    type="time"
                    aria-label={`${r.day} opens`}
                    value={r.range.start}
                    onChange={(e) => patch(r.key, { range: { ...r.range, start: e.target.value } })}
                    style={{ width: 120 }}
                  />
                  <span style={{ color: '#8c8c8c' }}>to</span>
                  <Input
                    type="time"
                    aria-label={`${r.day} closes`}
                    value={r.range.end}
                    onChange={(e) => patch(r.key, { range: { ...r.range, end: e.target.value } })}
                    style={{ width: 120 }}
                  />
                </>
              )}
            </div>
          ))}
          <Button type="primary" onClick={save} loading={saving} style={{ marginTop: 8 }}>
            Save hours
          </Button>
        </>
      )}
    </Card>
  );
}
